import { render } from "./service.vue?vue&type=template&id=5e2ceb16&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"

import "./service.vue?vue&type=style&index=0&id=5e2ceb16&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2ceb16"]])

export default __exports__